import { ApiException, ApiOffer, ApiOfferPosition, FileParameter } from '@api/api';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ILevelNode } from '../../project-details-view/projects-details-offer/offer.service';

export const OfferActions = createActionGroup({
  source: 'Offer',
  events: {
    'Offer saved': props<{ projectId: string }>(),
    'Final Measurment saved': props<{ projectId: string }>(),
    'Final Measurment initiated': props<{ projectId: string }>(),
    'Init Final Measurement': props<{
      projectId: string;
      serviceAcceptanceDate: Date;
      serviceAcceptanceDocument: FileParameter;
      defectsFixed: boolean;
    }>(),
    'Offer finalized': props<{ projectId: string }>(),
    'Final Measurment finalized': emptyProps(),
    'General Agreement loaded': props<{
      generalAgreements: ILevelNode[];
    }>(),
    'Offer loaded': props<{ offer: ApiOffer }>(),
    'Load offer failed': props<{ error: ApiException }>(),
    'Final Measurement loaded': props<{
      finalMeasurement: ApiOffer;
    }>(),
    'Load final measurement failed': props<{ error: ApiException }>(),
    'Add offer position': props<{ offerPosition: ApiOfferPosition }>(),
    'Delete offer position': props<{ offerPosition: ApiOfferPosition }>(),
    'Update offer position': props<{ offerPosition: ApiOfferPosition }>(),
    'Add final measurement position': props<{ offerPosition: ApiOfferPosition }>(),
    'Delete final measurement position': props<{ offerPosition: ApiOfferPosition }>(),
    'Update final measurement position': props<{ offerPosition: ApiOfferPosition }>(),
    'Persist offer': props<{
      projectId: string;
      isNew: boolean;
      offerPositions: ApiOfferPosition[];
    }>(),
    'Persist final measurement': props<{
      projectId: string;
      isNew: boolean;
      finalMeasurementPositions: ApiOfferPosition[];
    }>(),
    'Finalize offer': props<{
      projectId: string;
      offerPositions: ApiOfferPosition[];
      airConditionVentilation: string;
    }>(),
    'Finalize final measurement': props<{
      projectId: string;
      finalMeasurementPositions: ApiOfferPosition[];
      reason: string | null | undefined;
      airConditionVentilation: string;
    }>(),
    'Reset final measurement': emptyProps(),
    'Update offer handling positions': props<{ handlingPositions: ApiOfferPosition[] }>(),
    'Update final measurement handling positions': props<{
      handlingPositions: ApiOfferPosition[];
    }>(),
  },
});
